/* START_MODULE_CONTRACT
 * PURPOSE: Хук поля с blur-валидацией и защитой от ложного touched при открытии диалога.
 * SCOPE: value, showError, touch, reset, onChange, onBlur.
 * DEPENDS: react, useDialogFormReady (formReady)
 * LINKS: M-FE-APP
 * ROLE: RUNTIME
 * MAP_MODE: EXPORTS
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * useBlurValidatedField - управление значением, touched и ошибкой одного поля.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-13 - Общий хук blur-валидации для диалоговых форм.
 * END_CHANGE_SUMMARY
 */

import { useCallback, useState } from 'react';

/* START_METHOD_useBlurValidatedField */
/* START_CONTRACT: useBlurValidatedField
 * PURPOSE: Хранить значение поля и показывать ошибку после blur (если formReady) или touch().
 * INPUTS: { initialValue: string, validate: (value: string) => boolean, formReady: boolean }.
 * OUTPUTS: { value, setValue, isValid, showError, touch, reset, onChange, onBlur }.
 * SIDE_EFFECTS: локальный state.
 * LINKS: M-FE-APP
 * END_CONTRACT: useBlurValidatedField
 */
export function useBlurValidatedField(initialValue, validate, formReady) {
  const [value, setValue] = useState(initialValue);
  const [touched, setTouched] = useState(false);

  const isValid = validate(value);
  const showError = touched && !isValid;

  const touch = useCallback(() => {
    setTouched(true);
  }, []);

  const reset = useCallback((nextValue = initialValue) => {
    setValue(nextValue);
    setTouched(false);
  }, [initialValue]);

  const onBlur = useCallback(() => {
    if (formReady) {
      setTouched(true);
    }
  }, [formReady]);

  const onChange = useCallback((event) => {
    setValue(event.target.value);
  }, []);

  return {
    value,
    setValue,
    isValid,
    showError,
    touch,
    reset,
    onChange,
    onBlur,
  };
}
/* END_METHOD_useBlurValidatedField */
